import dayjs from 'dayjs';

import Pill from './Pill';

const LessThan90DaysOldPill = ({ date = null }) => {
  const ninetyDaysAgo = dayjs().subtract(90, 'day');
  const dateToCheck = dayjs(date);

  if (dateToCheck.isValid() && ninetyDaysAgo.isBefore(dateToCheck)) {
    return (
      <Pill data-testid="less-than-90-days-old" color="blue">
        Less Than 90 Days Old
      </Pill>
    );
  }
};

export default LessThan90DaysOldPill;
